// src/lib/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBBysa3ahJB9CYKvvlsSGUIUbChepsWJLA",
  authDomain: "playfast-eb4ac.firebaseapp.com",
  projectId: "playfast-eb4ac",
  storageBucket: "playfast-eb4ac.firebasestorage.app",
  messagingSenderId: "872248242891",
  appId: "1:872248242891:web:28592d8717f6f9543c614e",
  measurementId: "G-51ZBZBHTR0",
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);
